module.exports = __webpack_public_path__ + "static/media/Setup_green.f90e755f.png";